window.addEventListener(
  'unhandledrejection',
  (e) => {
    console.error('[Unhandled Rejection]', e.reason)
  },
  false,
)

import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import 'remixicon/fonts/remixicon.css'
import { render } from 'solid-js/web'
import { lazy, Show } from 'solid-js'
import 'flatpickr/dist/flatpickr.min.css'
import './index.css'
import '@lib/styles/components/form-field.scss'
import account, { keepalive } from '@lib/auth/account'
import Login from '@lib/auth/Login'

import dayjs from 'dayjs'
import UTC from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import IsoWeek from 'dayjs/plugin/isoWeek'

const App = lazy(() => import('./App.jsx'))

dayjs.extend(UTC)
dayjs.extend(Timezone)
dayjs.extend(LocalizedFormat)
dayjs.extend(IsoWeek)

const root = document.getElementById('root')

render(
  () => (
    <Show when={account().username} fallback={<Login appName="Staff" logo={null} enableTOTP={true} />}>
      <App />
    </Show>
  ),
  root,
)
